import { optional, string, z } from '@kaiizen/zod-less';

export const ApiKaiizenSkuSchema = z.object({
  kaiizenSku: string,
  homeDepotProductSku: optional(string),
  createdAt: string,
  updatedAt: string,
  archivedAt: optional(string),
});

export const ApiCreateKaiizenSkuSchema = z.object({
  homeDepotProductSku: optional(string),
});

export type ApiKaiizenSku = z.infer<typeof ApiKaiizenSkuSchema>;
export type ApiCreateKaiizenSku = z.infer<typeof ApiCreateKaiizenSkuSchema>;
